import { object, string } from "yup";

import { ClientGroup, OptizmoFormValues } from "./optizmo.types";

export const initialValues: OptizmoFormValues = {
  apiKey: "",
  clientGroupsRaw: "",
};

export function parseClientGroups(raw: string): ClientGroup[] {
  const groups: ClientGroup[] = [];

  for (const line of raw.split("\n")) {
    const trimmed = line.trim();
    if (!trimmed) continue;

    const parts = trimmed.split(",").map((p) => p.trim());
    const clientName = parts[0];
    const accessKeys = parts.slice(1).filter(Boolean);

    if (clientName && accessKeys.length > 0) {
      groups.push({ clientName, accessKeys });
    }
  }

  return groups;
}

export const validationSchema = object({
  apiKey: string().required("Affiliate Token is required"),
  clientGroupsRaw: string()
    .required("At least one client group is required")
    .test("has-groups", "Enter at least one line: Client Name, key1, key2", (value) => {
      if (!value) return false;
      return parseClientGroups(value).length > 0;
    }),
});
